// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b25f17f7","239":"224b0713","453":"d7bccffd","732":"756d3f37"}[chunkId] + ".chunk.js";
};